import { notifications } from "@mantine/notifications"
import { NOTIFICATION_TYPE_COLOR } from "~/shared/notification/constants"
import { AiOutlineInfo } from "react-icons/ai"
import { GrInfo } from "react-icons/gr"
import { LuCheck, LuX } from "react-icons/lu"
import type { NotificationType } from "~/shared/notification/constants"

const NOTIFICATION_TYPE_ICON: Record<NotificationType, React.ReactNode> = {
  success: <LuCheck />,
  error: <LuX />,
  warning: <GrInfo />,
  info: <AiOutlineInfo />,
} as const

interface NotificationProps {
  type: NotificationType
  title: string
  message: string | React.ReactNode
  loading?: boolean
}

export default function showNotification({
  type,
  title,
  message,
  loading = false,
  ...props
}: NotificationProps) {
  return notifications.show({
    title,
    icon: NOTIFICATION_TYPE_ICON[type],
    color: NOTIFICATION_TYPE_COLOR[type],
    message,
    radius: "md",
    position: "top-center",
    withCloseButton: true,
    loading,
    ...props,
  })
}
